<template>
    <div class="registerMain">
        <el-dialog
            :visible.sync="showRegister"
            :show-close="true"
            :append-to-body="true"
            width="380px"
            lock-scroll
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :center="true"
             @close="closeLogin"
        >
            <div class="dialogmain">
                <!-- <div class="closeicon" @click="closeLogin">
                    <svg-icon icon-class="close"></svg-icon>
                </div> -->
                <div class="titles">立即注册</div>
                <div class="userlogin">
                    <el-form :model="registerForm" status-icon :rules="rules" ref="ruleForm">
                        <el-form-item prop="MemberName">
                            <el-input
                                v-model="registerForm.MemberName"
                                placeholder="请输入您的真实姓名"
                                maxlength="10"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="CompanyName" class="getcode">
                            <el-input
                                v-model="registerForm.CompanyName"
                                @keyup.enter.native="submitForm('ruleForm')" 
                                placeholder="请输入您所在的律所"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item class="loginBtnForm">
                            <el-button type="primary" round @click="submitForm('ruleForm')" class="loginBtn" :loading="loading">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="descript">
                    请输入您的真实用户信息提交成功即可登录
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            registerForm:{
                MemberName:"",
                CompanyName:"",
            },
            loading:false,
            rules:{
                MemberName: [
                    { required: true, message: "请输入您的真实姓名", trigger: "change" },
                ],
                CompanyName: [
                    { required: true, message: "请输入您所在的律所", trigger: "change" },
                ]
            },
        }
    },
    computed:{
        showRegister() {
            return this.$store.state.showRegister
        },
    },
    methods:{
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    setTimeout(()=>{
                        this.loading = false;
                    },3000)
                    this.$store.commit("Registers",this.registerForm);
                    this.$refs[formName].resetFields();
                } else {
                    return false;
                }
            });
        },
        //关闭注册弹框
        closeLogin(){
            this.$store.commit("closeRegister")
        }
    },
}
</script>
<style lang="scss" scoped>
    // .registerMain{
        // height: 100%;
        .dialogmain{
            position: relative;
            padding-top: 50px;
            .titles{
                font-size: 22px;
                text-align: center;
                margin: 0px 0 50px;
            }
            .closeicon{
                position: absolute;
                top: 10px;
                right: 10px;
                cursor: pointer;
            }
            .userlogin{
                padding: 0 44px 28px;
                .getcode{
                    .el-form-item__content{
                        display: flex;
                    }
                    
                }
                .loginBtnForm{
                    text-align: center;
                    .loginBtn{
                        font-size: 18px;
                        padding: 16px 102px;
                        border-radius: 25px;
                        margin: 28px auto 0;
                        background: #2075F5;
                    }
                }
                .codemsg{
                    padding-top: 40px;
                    border-top: 1px solid #efefef;
                    font-size: 14px;
                    color: #777;
                    text-align: center;
                    margin-top: 50px;
                }
            }
            .descript{
                text-align: center;
                color: #777;
                font-size: 14px;
                padding: 34px 42px 34px;
                border-top: 1px solid #EFEFEF;
                width: 292px;
                margin: 0 auto;
            }
        }
    // }
</style>


// WEBPACK FOOTER //
// src/components/login/register.vue